(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6076],{

/***/ 40774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ArrowBack = function ArrowBack(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M50 27.5H19.575L33.55 13.525 30 10 10 30l20 20 3.525-3.525L19.575 32.5H50v-5z",
      fill: "#fff"
    })
  }));
};

var MemoArrowBack = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ArrowBack);
/* harmony default export */ __webpack_exports__["Z"] = (MemoArrowBack);

/***/ }),

/***/ 95345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PodcastPlayerWrapper": function() { return /* binding */ PodcastPlayerWrapper; },
  "default": function() { return /* binding */ podcast_player_wrapper_component; }
});

// EXTERNAL MODULE: ./app/store/slices/player.ts
var player = __webpack_require__(22564);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./app/components/podcast-player/podcast-player.module.scss
var podcast_player_module = __webpack_require__(68525);
var podcast_player_module_default = /*#__PURE__*/__webpack_require__.n(podcast_player_module);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./app/components/icons/Play.tsx
var Play = __webpack_require__(43935);
// EXTERNAL MODULE: ./app/components/icons/Pause.tsx
var Pause = __webpack_require__(82334);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useInterval.js
var useInterval = __webpack_require__(43337);
// EXTERNAL MODULE: ./app/components/icons/Loader.tsx
var Loader = __webpack_require__(37387);
// EXTERNAL MODULE: ./app/hooks/spacebar.hook.ts
var spacebar_hook = __webpack_require__(28395);
// EXTERNAL MODULE: ./services-hooks/services.ts + 1 modules
var services = __webpack_require__(46725);
// EXTERNAL MODULE: ./app/hooks/favorites.hook.ts
var favorites_hook = __webpack_require__(18958);
// EXTERNAL MODULE: ./app/components/toast/toast.component.tsx + 1 modules
var toast_component = __webpack_require__(53483);
// EXTERNAL MODULE: ./app/context/player.context.tsx
var player_context = __webpack_require__(48346);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./app/components/icons/HeartOutline.tsx
var HeartOutline = __webpack_require__(9761);
// EXTERNAL MODULE: ./app/components/podcast-player/podcast-player-fullscreen.module.scss
var podcast_player_fullscreen_module = __webpack_require__(80874);
var podcast_player_fullscreen_module_default = /*#__PURE__*/__webpack_require__.n(podcast_player_fullscreen_module);
// EXTERNAL MODULE: ./app/hooks/modal-scroll.hook.ts
var modal_scroll_hook = __webpack_require__(76299);
// EXTERNAL MODULE: ./app/components/icons/AngleDown.tsx
var AngleDown = __webpack_require__(37526);
// EXTERNAL MODULE: ./app/components/icons/Info.tsx
var Info = __webpack_require__(42924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/icons/WindForward.tsx




var WindForward = function WindForward(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$withText = _ref.withText,
      withText = _ref$withText === void 0 ? false : _ref$withText;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m47.766 26.738 11.7-11.7-11.7-11.702",
      stroke: "#fff",
      strokeWidth: 6.326,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M73.257 45.372a30.337 30.337 0 1 1-30.338-30.337h16.548",
      stroke: "#fff",
      strokeWidth: 6.326,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), withText && /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M37.188 56.357h-3.29V40.47l-4.851 1.658v-2.786l7.72-2.84h.42v19.856Zm19.775-8.331c0 2.845-.535 4.992-1.604 6.442-1.06 1.44-2.677 2.161-4.852 2.161-2.138 0-3.75-.702-4.838-2.106-1.078-1.414-1.631-3.502-1.658-6.266v-3.425c0-2.845.53-4.979 1.59-6.401 1.069-1.423 2.695-2.134 4.879-2.134 2.166 0 3.778.693 4.839 2.08 1.069 1.386 1.617 3.46 1.644 6.224v3.425Zm-3.303-3.697c0-1.857-.253-3.216-.76-4.077-.508-.87-1.314-1.305-2.42-1.305-1.078 0-1.871.412-2.378 1.237-.508.815-.775 2.093-.802 3.833v4.485c0 1.848.258 3.225.774 4.131.517.906 1.328 1.36 2.433 1.36 1.06 0 1.844-.417 2.352-1.25.507-.843.774-2.157.801-3.942v-4.472Z",
      fill: "#fff"
    })]
  });
};

var MemoWindForward = /*#__PURE__*/react.memo(WindForward);
/* harmony default export */ var icons_WindForward = (MemoWindForward);
;// CONCATENATED MODULE: ./app/components/icons/WindBack.tsx




var WindBack = function WindBack(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$withText = _ref.withText,
      withText = _ref$withText === void 0 ? false : _ref$withText;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m40.568 26.736-11.7-11.7 11.7-11.702",
      stroke: "#fff",
      strokeWidth: 6.326,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M15.077 45.372a30.337 30.337 0 1 0 30.338-30.337H28.867",
      stroke: "#fff",
      strokeWidth: 6.326,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), withText && /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M41.172 56.357h-3.29V40.47l-4.851 1.658v-2.786l7.72-2.84h.42v19.856Zm19.775-8.331c0 2.845-.535 4.992-1.604 6.442-1.06 1.44-2.677 2.161-4.852 2.161-2.138 0-3.751-.702-4.838-2.106-1.079-1.414-1.631-3.502-1.658-6.266v-3.425c0-2.845.53-4.979 1.59-6.401 1.069-1.423 2.695-2.134 4.879-2.134 2.166 0 3.778.693 4.838 2.08 1.07 1.386 1.618 3.46 1.645 6.224v3.425Zm-3.303-3.697c0-1.857-.253-3.216-.76-4.077-.508-.87-1.315-1.305-2.42-1.305-1.078 0-1.871.412-2.378 1.237-.508.815-.775 2.093-.802 3.833v4.485c0 1.848.258 3.225.774 4.131.517.906 1.328 1.36 2.433 1.36 1.06 0 1.844-.417 2.351-1.25.508-.843.775-2.157.802-3.942v-4.472Z",
      fill: "#fff"
    })]
  });
};

var MemoWindBack = /*#__PURE__*/react.memo(WindBack);
/* harmony default export */ var icons_WindBack = (MemoWindBack);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/nouislider-react/dist/nouislider-react.umd.production.min.js
var nouislider_react_umd_production_min = __webpack_require__(72037);
var nouislider_react_umd_production_min_default = /*#__PURE__*/__webpack_require__.n(nouislider_react_umd_production_min);
// EXTERNAL MODULE: ./node_modules/nouislider/distribute/nouislider.css
var nouislider = __webpack_require__(94987);
// EXTERNAL MODULE: ./app/components/progress-slider/progress-slider.module.scss
var progress_slider_module = __webpack_require__(2456);
var progress_slider_module_default = /*#__PURE__*/__webpack_require__.n(progress_slider_module);
;// CONCATENATED MODULE: ./app/components/progress-slider/progress-slider.component.tsx


var _excluded = ["progress", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ProgressSlider = function ProgressSlider(_ref) {
  var progress = _ref.progress,
      disabled = _ref.disabled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var ref = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (ref.current) {
      ref.current.noUiSlider.set(progress);
    }
  }, [progress]);
  (0,react.useEffect)(function () {
    if (ref.current) {
      if (disabled) {
        ref.current.setAttribute('disabled', true);
      } else {
        ref.current.removeAttribute('disabled');
      }
    }
  }, [disabled]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((nouislider_react_umd_production_min_default()), _objectSpread({
    animate: false,
    connect: [true, false],
    className: (progress_slider_module_default()).slider,
    instanceRef: function instanceRef(instance) {
      if (instance && !ref.current) {
        ref.current = instance;
      }
    }
  }, props));
};
// EXTERNAL MODULE: ./app/components/icons/HeartFull.tsx
var HeartFull = __webpack_require__(1919);
// EXTERNAL MODULE: ./app/hooks/keyboard-navigation.hook.ts
var keyboard_navigation_hook = __webpack_require__(36158);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 8 modules
var CSSTransition = __webpack_require__(41365);
// EXTERNAL MODULE: ./app/utils/date.ts
var date = __webpack_require__(20811);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js + 1 modules
var useWindowSize = __webpack_require__(37345);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useNetworkState.js
var useNetworkState = __webpack_require__(6765);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(69293);
// EXTERNAL MODULE: ./app/components/icons/ArrowBack.tsx
var ArrowBack = __webpack_require__(40774);
// EXTERNAL MODULE: ./app/hooks/navigation.hook.ts
var navigation_hook = __webpack_require__(26793);
;// CONCATENATED MODULE: ./app/components/icons/SpeedControl.tsx


function SpeedControl_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SpeedControl_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SpeedControl_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SpeedControl_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var SpeedControl = function SpeedControl(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", SpeedControl_objectSpread(SpeedControl_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 101 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      filter: "url(#a)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M9.659 42.282c-.518 3.63-6.02 2.843-5.497-.811A46.896 46.896 0 0 1 19.79 12.83C27.924 5.739 38.556 1.445 50.127 1.445c5.237 0 10.274.881 14.985 2.5l-3.938 4.627a40.606 40.606 0 0 0-11.047-1.523A40.52 40.52 0 0 0 23.42 17.052a41.286 41.286 0 0 0-13.76 25.23Zm52.35 5.65a12.118 12.118 0 0 1-1.437 3.996c-3.328 5.813-10.714 7.789-16.48 4.449-5.7-3.32-7.548-11.199-4.427-16.651a12.046 12.046 0 0 1 2.755-3.288L72.64.981c2.013-2.337 5.74-.129 4.726 2.75L62.009 47.933Zm-8.632-7.807a6.478 6.478 0 0 0-8.9 2.401c-1.806 3.153-.767 7.165 2.377 8.997 2.937 1.855 7.217.556 8.914-2.41 1.806-3.153.736-7.168-2.39-8.988Zm25.346-28.737 1.744 1.44A46.915 46.915 0 0 1 96.092 41.47c.526 3.655-4.98 4.443-5.498.811a41.289 41.289 0 0 0-13.76-25.23l-.065-.058 1.954-5.604Z",
        fill: "#fff"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "a",
        x: 0.127,
        y: 0,
        width: 100,
        height: 66,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_6092_9903"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_6092_9903",
          result: "shape"
        })]
      })
    })]
  }));
};

var MemoSpeedControl = /*#__PURE__*/(0,react.memo)(SpeedControl);
/* harmony default export */ var icons_SpeedControl = (MemoSpeedControl);
;// CONCATENATED MODULE: ./app/components/icons/BigPlus.tsx


function BigPlus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BigPlus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BigPlus_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BigPlus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var BigPlus = function BigPlus(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", BigPlus_objectSpread(BigPlus_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 138 138",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      filter: "url(#prefix__filter0_d_6092_9945)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M69 0c35.879 0 65 29.121 65 65 0 35.879-29.121 65-65 65-35.879 0-65-29.121-65-65C4 29.121 33.121 0 69 0zm-3.861 61.138H38.914c-5.149 0-5.149 7.722 0 7.722h26.225v26.386c0 4.988 7.722 4.988 7.722 0V68.86h26.386c4.988 0 4.988-7.722 0-7.722H72.861V34.913c0-5.148-7.722-5.148-7.722 0v26.225zM69 3.217c-34.107 0-61.78 27.673-61.78 61.78 0 34.27 27.673 61.944 61.78 61.944 34.27 0 61.944-27.673 61.944-61.943C130.944 30.89 103.27 3.217 69 3.217z",
        fill: "#fff"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "prefix__filter0_d_6092_9945",
        x: 0,
        y: 0,
        width: 138,
        height: 138,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_6092_9945"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_6092_9945",
          result: "shape"
        })]
      })
    })]
  }));
};

var MemoBigPlus = /*#__PURE__*/(0,react.memo)(BigPlus);
/* harmony default export */ var icons_BigPlus = (MemoBigPlus);
;// CONCATENATED MODULE: ./app/components/icons/BigMinus.tsx


function BigMinus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BigMinus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BigMinus_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BigMinus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var BigMinus = function BigMinus(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", BigMinus_objectSpread(BigMinus_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 138 138",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      filter: "url(#prefix__filter0_d_6092_9947)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M69 0c35.879 0 65 29.121 65 65 0 35.879-29.121 65-65 65-35.879 0-65-29.121-65-65C4 29.121 33.121 0 69 0zm-3.861 61.138H38.914c-5.149 0-5.149 7.722 0 7.722h60.333c4.988 0 4.988-7.722 0-7.722H65.14zM69 3.217c-34.107 0-61.78 27.673-61.78 61.78 0 34.27 27.673 61.944 61.78 61.944 34.27 0 61.944-27.673 61.944-61.943C130.944 30.89 103.27 3.217 69 3.217z",
        fill: "#fff"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "prefix__filter0_d_6092_9947",
        x: 0,
        y: 0,
        width: 138,
        height: 138,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_6092_9947"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_6092_9947",
          result: "shape"
        })]
      })
    })]
  }));
};

var MemoBigMinus = /*#__PURE__*/(0,react.memo)(BigMinus);
/* harmony default export */ var icons_BigMinus = (MemoBigMinus);
// EXTERNAL MODULE: ./app/components/icons/Playlist.tsx
var Playlist = __webpack_require__(41127);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 21 modules
var format = __webpack_require__(19802);
// EXTERNAL MODULE: ./app/utils/language.ts + 105 modules
var language = __webpack_require__(79490);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
// EXTERNAL MODULE: ./app/store/slices/user.ts
var user = __webpack_require__(38886);
// EXTERNAL MODULE: ./app/components/station-player/vlyby-container.component.tsx
var vlyby_container_component = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./app/components/ui/button.component.tsx
var button_component = __webpack_require__(61947);
// EXTERNAL MODULE: ./app/context/country.context.tsx
var country_context = __webpack_require__(91537);
;// CONCATENATED MODULE: ./app/components/podcast-player/podcast-player-fullscreen.component.tsx














































var PlayerFullScreen = function PlayerFullScreen(_ref) {
  var _clsx, _podcastChapter$logo;

  var playerCssVariables = _ref.playerCssVariables,
      podcastChapter = _ref.podcastChapter,
      podcast = _ref.podcast,
      onClose = _ref.onClose,
      playbackState = _ref.playbackState,
      playbackControls = _ref.playbackControls,
      open = _ref.open;
  var navigatePath = (0,navigation_hook/* useNavigatePath */.xQ)();

  var _useFavorites = (0,favorites_hook/* useFavorites */.r)(function () {
    onClose();
    navigatePath("/log-in", true, {
      openplayer: true
    });
  }),
      toggleFavorite = _useFavorites.toggleFavorite,
      loading = _useFavorites.loading,
      isFavoriteCategory = _useFavorites.isFavoriteCategory;

  var _useState = (0,react.useState)(0),
      currentTime = _useState[0],
      setCurrentTime = _useState[1];

  var _useState2 = (0,react.useState)(false),
      streamDragging = _useState2[0],
      setStreamDragging = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      sidebarOpen = _useState3[0],
      setSidebarOpen = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      speedSidebarOpen = _useState4[0],
      setSpeedSidebarOpen = _useState4[1];

  var goToPodcast = (0,navigation_hook/* useGoToPodcast */.IT)();
  (0,useInterval/* default */.Z)(function () {
    if (!streamDragging) {
      setCurrentTime(playbackState.time);
    }
  }, 1000);
  var speedStep = 0.25;

  var playbackSpeedUp = function playbackSpeedUp() {
    if (playbackState.playbackRate < 2 && !playbackState.activeAdStream) {
      playbackControls.setPlaybackRate(playbackState.playbackRate + speedStep);
    }
  };

  var playbackSpeedDown = function playbackSpeedDown() {
    if (playbackState.playbackRate > 2 * speedStep && !playbackState.activeAdStream) {
      playbackControls.setPlaybackRate(playbackState.playbackRate - speedStep);
    }
  };

  var goToPodcastDetails = function goToPodcastDetails() {
    goToPodcast("/".concat(podcast.permalink));
    onClose();
  };

  (0,modal_scroll_hook/* default */.Z)(open);
  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("PodcastPlayerFullScreen", goBackCallback, open && !sidebarOpen && !speedSidebarOpen);

  var formatTime = function formatTime(seconds) {
    if (seconds !== undefined) {
      var secondsDiff = seconds;
      var hoursDiff = Math.floor(secondsDiff / 3600);
      secondsDiff -= hoursDiff * 3600;
      var minutesDiff = Math.floor(secondsDiff / 60);
      secondsDiff -= minutesDiff * 60;
      secondsDiff |= 0;
      return "".concat(hoursDiff.toString().padStart(2, "0"), ":").concat(minutesDiff.toString().padStart(2, "0"), ":").concat(secondsDiff.toString().padStart(2, "0"));
    }

    return "";
  };

  var handleChange = function handleChange(values) {
    if (!playbackState.activeAdStream) {
      playbackControls.seek(Number(values[0]));
      setStreamDragging(false);
    }
  };

  var playerRange = (0,react.useMemo)(function () {
    return {
      min: 0,
      max: playbackState.duration
    };
  }, [playbackState.duration]);
  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)(open);

  var jumpForward = function jumpForward() {
    if (!playbackState.activeAdStream) {
      playbackControls.seek(playbackState.time + 10);
    }
  };

  var jumpBack = function jumpBack() {
    if (!playbackState.activeAdStream) {
      playbackControls.seek(playbackState.time - 10);
    }
  };

  var sidebarCloseCallback = (0,react.useCallback)(function () {
    return setSidebarOpen(false);
  }, [setSidebarOpen]);
  var speedSidebarCloseCallback = (0,react.useCallback)(function () {
    return setSpeedSidebarOpen(false);
  }, [setSpeedSidebarOpen]); // VLYBY

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector.session;

  var t = (0,lang/* useTranslate */.q)();

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      premiumVersion = _useFeaturesContext.premiumVersion,
      vlybyPublisherId = _useFeaturesContext.vlybyPublisherId;

  var _useCountryContext = (0,country_context/* useCountryContext */.o)(),
      country = _useCountryContext.country;

  var _useState5 = (0,react.useState)(false),
      videoAdActive = _useState5[0],
      setVideoAdActive = _useState5[1];

  var _useWindowSize = (0,useWindowSize/* default */.Z)(),
      width = _useWindowSize.width,
      height = _useWindowSize.height;

  var controlsContainerRef = (0,react.useRef)(null);

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      setGlobalAdCloseTime = _usePlayerContext.setGlobalAdCloseTime,
      globalAdCloseTime = _usePlayerContext.globalAdCloseTime,
      checkGlobalTimer = _usePlayerContext.checkGlobalTimer,
      priceData = _usePlayerContext.priceData;

  var networkState = (0,useNetworkState/* default */.Z)();
  var enableVlyby = !!vlybyPublisherId && !premiumVersion;

  var _useState6 = (0,react.useState)(false),
      isVlybyAdReady = _useState6[0],
      setIsVlybyAdReady = _useState6[1];

  var _useState7 = (0,react.useState)(true),
      isFirstVlybyAdPlay = _useState7[0],
      setIsFirstVlybyAdPlay = _useState7[1];

  var getIsPageVisible = (0,react.useCallback)(function () {
    if (true) {
      return window.document.visibilityState === "visible";
    }

    return true;
  }, [window]);

  var _useState8 = (0,react.useState)(false),
      isAdblockDetected = _useState8[0],
      setIsAdblockDetected = _useState8[1];

  var hideAdTimeoutId = (0,react.useRef)(null);
  var showAdTimeoutId = (0,react.useRef)(null);
  var adFreeTime = 3 * 60000; //3min

  var firstAudioAdTimeout = 30000; //30s

  (0,react.useEffect)(function () {
    try {
      if (true) {
        window.innerHideVlybyPlayer = function () {
          stopVlybyVideoAds(window.isVlybyAdReady);
        };

        window.innerVlybyAdReady = function () {
          window.isVlybyAdReady = true;
          setIsVlybyAdReady(true);
        };
      }
    } catch (error) {}

    return function () {
      try {
        if (true) {
          delete window.innerHideVlybyPlayer;
          delete window.innerVlybyAdReady;
          delete window.isVlybyAdReady;
        }

        clearTimeout(hideAdTimeoutId.current);
        clearTimeout(showAdTimeoutId.current);
      } catch (error) {}
    };
  }, []);

  var stopVlybyVideoAds = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var isSuccess,
          stopNextTimeout,
          isAdError,
          _args = arguments;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isSuccess = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              stopNextTimeout = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              isAdError = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              console.log("stopVlybyVideoAds");
              clearTimeout(hideAdTimeoutId.current);
              clearTimeout(showAdTimeoutId.current);
              window.isVlybyAdReady = false;
              setIsVlybyAdReady(false);
              setVideoAdActive(false);
              setShowVlyby(false);

              if (isSuccess) {
                setGlobalAdCloseTime(Number(Date.now()));
              }

              if (enableVlyby && !stopNextTimeout) {
                showAdTimeoutId.current = setTimeout(function () {
                  startLoadingVlyby();
                }, isAdError ? player_context/* VLYBY_AD_ERROR_TIMEOUT */.Ld : adFreeTime);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function stopVlybyVideoAds() {
      return _ref2.apply(this, arguments);
    };
  }(); // test adblock


  (0,react.useEffect)(function () {
    if (true) {
      var _window$getComputedSt;

      var adBoxEl = window.document.querySelector(".ad-box");
      setIsAdblockDetected(!!adBoxEl && ((_window$getComputedSt = window.getComputedStyle(adBoxEl)) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.display) === "none");
    }
  }, []);

  var _useState9 = (0,react.useState)(false),
      showVlyby = _useState9[0],
      setShowVlyby = _useState9[1];

  var startLoadingVlyby = function startLoadingVlyby() {
    if (!videoAdActive) {
      var _session$user;

      clearTimeout(hideAdTimeoutId.current);
      var localCheck = !!vlybyPublisherId && country.countryCode !== "de" && getIsPageVisible() && !(session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.premium) && !isAdblockDetected;
      console.log("[[VLYBY]] START LOADING", localCheck, {
        open: open,
        isFirstVlybyAdPlay: isFirstVlybyAdPlay,
        globalAdCloseTime: globalAdCloseTime,
        timer: checkGlobalTimer()
      });
      updateShowVlyby();
    }
  };

  var updateShowVlyby = function updateShowVlyby() {
    var _session$user2;

    var localCheck = enableVlyby && getIsPageVisible() && !(session !== null && session !== void 0 && (_session$user2 = session.user) !== null && _session$user2 !== void 0 && _session$user2.premium) && !isAdblockDetected; // open &&

    setShowVlyby(localCheck);
    setVideoAdActive(localCheck);

    if (localCheck) {
      clearTimeout(hideAdTimeoutId.current);
      hideAdTimeoutId.current = setTimeout(function () {
        if (true) {
          console.log("[[VLYBY]] timeout", hideTimeout, isVlybyAdReady, window.isVlybyAdReady, showVlyby, localCheck);

          if (!window.isVlybyAdReady) {
            stopVlybyVideoAds(false, false, true);
          }
        }
      }, hideTimeout);
    } else {
      stopVlybyVideoAds();
    }
  };

  var hideTimeout = (0,react.useMemo)(function () {
    if (networkState.effectiveType) {
      if (["2g", "slow-2g"].includes(networkState.effectiveType)) {
        return 30000;
      }

      if (["3g"].includes(networkState.effectiveType)) {
        return 15000;
      }
    }

    return 10000;
  }, [networkState]); // start loading vlyby

  (0,react.useEffect)(function () {
    clearTimeout(hideAdTimeoutId.current);
    clearTimeout(showAdTimeoutId.current);

    if (enableVlyby && open && isFirstVlybyAdPlay) {
      // first ad after 30s
      showAdTimeoutId.current = setTimeout(function () {
        console.log("FIRST LOAD");
        setIsFirstVlybyAdPlay(false);
        startLoadingVlyby();
      }, checkGlobalTimer() ? firstAudioAdTimeout : player_context/* VLYBY_TIMEOUT */.UU - (Number(Date.now()) - globalAdCloseTime) + 10);
    } else if (enableVlyby && !open) {
      window.isVlybyAdReady = false;
      setIsVlybyAdReady(false);
      setVideoAdActive(false);
      setShowVlyby(false);
      setIsFirstVlybyAdPlay(true);
    }
  }, [open]);

  var getAdContainerMaximumSize = function getAdContainerMaximumSize() {
    var _controlsContainerRef;

    var maxWidth = 960;

    if (window.innerWidth < 1920) {
      maxWidth = 880;
    }

    if (window.innerWidth < 1600) {
      maxWidth = 600;
    }

    if (window.innerWidth < 1380) {
      maxWidth = 500;
    }

    var maximumHeight = window.innerHeight - 252 - (((_controlsContainerRef = controlsContainerRef.current) === null || _controlsContainerRef === void 0 ? void 0 : _controlsContainerRef.clientHeight) || 0);
    var proportionalMaximumWidth = maximumHeight * (16 / 9);
    var maximumWidth = proportionalMaximumWidth > maxWidth ? maxWidth : proportionalMaximumWidth;
    var desiredWidth = window.innerWidth - 80 > maximumWidth ? maximumWidth : window.innerWidth - 80;
    var desiredHeight = desiredWidth * (9 / 16);
    return {
      desiredHeight: desiredHeight,
      desiredWidth: desiredWidth
    };
  };

  var _useState10 = (0,react.useState)(""),
      adPlayerWidth = _useState10[0],
      setAdPlayerWidth = _useState10[1];

  var _useState11 = (0,react.useState)(""),
      adPlayerHeight = _useState11[0],
      setAdPlayerHeight = _useState11[1];

  (0,react.useEffect)(function () {
    if (enableVlyby) {
      var _getAdContainerMaximu = getAdContainerMaximumSize(),
          desiredHeight = _getAdContainerMaximu.desiredHeight,
          desiredWidth = _getAdContainerMaximu.desiredWidth;

      setAdPlayerWidth("".concat(desiredWidth, "px"));
      setAdPlayerHeight("".concat(desiredHeight, "px"));
    }
  }, [width, height]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
    nodeRef: wrapperRef,
    in: open,
    timeout: 400,
    classNames: {
      enterActive: (podcast_player_fullscreen_module_default()).player_fullscreen_enter_active,
      enter: (podcast_player_fullscreen_module_default()).player_fullscreen_enter,
      enterDone: (podcast_player_fullscreen_module_default()).player_fullscreen_enter_done,
      exit: (podcast_player_fullscreen_module_default()).player_fullscreen_exit,
      exitActive: (podcast_player_fullscreen_module_default()).player_fullscreen_exit_active,
      exitDone: (podcast_player_fullscreen_module_default()).player_fullscreen_exit_done
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (podcast_player_fullscreen_module_default()).player_fullscreen,
      ref: wrapperRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (podcast_player_fullscreen_module_default()).player_fullscreen_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (podcast_player_fullscreen_module_default()).player_fullscreen_content,
          style: playerCssVariables,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (podcast_player_fullscreen_module_default()).player_fullscreen_inner,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (podcast_player_fullscreen_module_default()).player_fullscreen_header,
              "data-navigate-row": open,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                onClick: function onClick() {
                  return onClose();
                },
                "data-navigate-item": open,
                className: (podcast_player_fullscreen_module_default()).player_fullscreen_close,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(AngleDown/* default */.Z, {})
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).player_fullscreen_track),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).player_fullscreen_track, (podcast_player_fullscreen_module_default()).player_fullscreen_ad_wrapper, (_clsx = {}, (0,defineProperty/* default */.Z)(_clsx, (podcast_player_fullscreen_module_default()).video_ad, showVlyby), (0,defineProperty/* default */.Z)(_clsx, (podcast_player_fullscreen_module_default()).invisible, !videoAdActive && !showVlyby), (0,defineProperty/* default */.Z)(_clsx, (podcast_player_fullscreen_module_default()).video_ad_ready, window.isVlybyAdReady), _clsx)),
                children: [window.isVlybyAdReady && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (podcast_player_fullscreen_module_default()).video_ad_header,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/get-premium",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        "data-navigate-row": videoAdActive || showVlyby,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* Button */.zx, {
                          accent: true,
                          "data-navigate-item": videoAdActive || showVlyby,
                          "data-navigate-noscroll": true,
                          className: (podcast_player_fullscreen_module_default()).premium_button,
                          onClick: function onClick() {
                            return onClose();
                          },
                          children: t("premium.go-premium-for", {
                            var1: "".concat(priceData.amount).concat(priceData.currency_symbol)
                          })
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (podcast_player_fullscreen_module_default()).ad_header,
                    children: t("premium.video-ad-description")
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (podcast_player_fullscreen_module_default()).ad_player,
                  style: {
                    display: !showVlyby ? "none" : undefined,
                    margin: "0px auto",
                    maxWidth: "853px"
                  },
                  children: showVlyby && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (podcast_player_fullscreen_module_default()).vlyby_container,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(vlyby_container_component/* VlybyContainer */.L, {
                      width: adPlayerWidth,
                      height: adPlayerHeight
                    })
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: (_podcastChapter$logo = podcastChapter.logo) !== null && _podcastChapter$logo !== void 0 ? _podcastChapter$logo : podcast.logo,
                alt: "",
                className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).podcast_logo, (0,defineProperty/* default */.Z)({}, (podcast_player_fullscreen_module_default()).invisible, window.isVlybyAdReady))
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).player_fullscreen_track_info, (0,defineProperty/* default */.Z)({}, (podcast_player_fullscreen_module_default()).invisible, window.isVlybyAdReady)),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).podcast_details, (0,defineProperty/* default */.Z)({}, (podcast_player_fullscreen_module_default()).invisible, window.isVlybyAdReady)),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                    className: (podcast_player_fullscreen_module_default()).title,
                    children: podcast.name
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).chapter_details, (0,defineProperty/* default */.Z)({}, (podcast_player_fullscreen_module_default()).invisible, window.isVlybyAdReady)),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: podcastChapter.name
                  }), podcastChapter.summary ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (podcast_player_fullscreen_module_default()).subtitle,
                    children: podcastChapter.summary
                  }) : podcast.description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (podcast_player_fullscreen_module_default()).subtitle,
                    children: podcast.description
                  })]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).player_fullscreen_controls, (0,defineProperty/* default */.Z)({}, (podcast_player_fullscreen_module_default()).video_ad_ready, window.isVlybyAdReady)),
              "data-navigate-row": open,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).button_secondary, (podcast_player_fullscreen_module_default()).controls_first),
                "data-navigate-item": open,
                onClick: function onClick() {
                  return goToPodcastDetails();
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Info/* default */.Z, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).button_priamry, (podcast_player_fullscreen_module_default()).heart),
                onClick: function onClick() {
                  return toggleFavorite(podcast, playbackState.playing);
                },
                "data-navigate-item": open,
                "data-navigate-noscroll": true,
                children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : isFavoriteCategory(podcast) ? /*#__PURE__*/(0,jsx_runtime.jsx)(HeartFull/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(HeartOutline/* default */.Z, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).play, (0,defineProperty/* default */.Z)({}, (podcast_player_fullscreen_module_default()).show_play, !playbackState.playing)),
                "data-navigate-item": open,
                "data-navigate-noscroll": true,
                onClick: function onClick(e) {
                  e.stopPropagation();
                  playbackControls.toggle();
                },
                children: playbackState.loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : playbackState.playing ? /*#__PURE__*/(0,jsx_runtime.jsx)(Pause/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(Play/* default */.Z, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).button_priamry),
                id: "speed-control-button",
                onClick: function onClick() {
                  return setSpeedSidebarOpen(true);
                },
                "data-navigate-item": open,
                "data-navigate-noscroll": true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_SpeedControl, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).button_secondary, (podcast_player_fullscreen_module_default()).controls_last),
                onClick: function onClick() {
                  return setSidebarOpen(true);
                },
                "data-navigate-item": open,
                "data-navigate-noscroll": true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Playlist/* default */.Z, {})
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              "data-navigate-row": open,
              className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).player_fullscreen_progress_wrapper, (podcast_player_fullscreen_module_default()).player_fullscreen_controls, (0,defineProperty/* default */.Z)({}, (podcast_player_fullscreen_module_default()).video_ad_ready_progress, window.isVlybyAdReady)),
              children: playbackState.duration !== null && playbackState.duration > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  "data-navigate-item": open,
                  "data-navigate-noscroll": true,
                  className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).button_secondary, (podcast_player_fullscreen_module_default()).button_jump),
                  onClick: function onClick() {
                    return jumpBack();
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_WindBack, {
                    withText: true
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (podcast_player_fullscreen_module_default()).player_fullscreen_track_wrapper,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProgressSlider, {
                    range: playerRange,
                    start: 0,
                    progress: currentTime,
                    onChange: handleChange,
                    onStart: function onStart() {
                      return setStreamDragging(true);
                    },
                    disabled: !!playbackState.activeAdStream
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (podcast_player_fullscreen_module_default()).player_fullscreen_time,
                    children: formatTime(currentTime)
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).player_fullscreen_time, (podcast_player_fullscreen_module_default()).player_fullscreen_time_end),
                    children: formatTime(playbackState.duration)
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  "data-navigate-item": open,
                  "data-navigate-noscroll": true,
                  className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).button_secondary, (podcast_player_fullscreen_module_default()).button_jump),
                  onClick: function onClick() {
                    return jumpForward();
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_WindForward, {
                    withText: true
                  })
                })]
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PodcastSidebar, {
          open: sidebarOpen,
          podcast: podcast,
          onClose: sidebarCloseCallback
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PodcastSpeedSidebar, {
          open: speedSidebarOpen,
          onClose: speedSidebarCloseCallback,
          currentSpeed: playbackState.playbackRate,
          onSpeedUp: playbackSpeedUp,
          onSpeedDown: playbackSpeedDown,
          podcastChapter: podcastChapter
        })]
      })
    })
  });
};

var PodcastSidebar = function PodcastSidebar(_ref3) {
  var open = _ref3.open,
      onClose = _ref3.onClose;
  var sidebarRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)(open);

  var _useAppSelector2 = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA),
      podcastQueue = _useAppSelector2.podcastQueue;

  var dispatch = (0,store/* useAppDispatch */.TL)();

  var formatPublishDate = function formatPublishDate(dateString) {
    try {
      var parsedDate = (0,parseISO/* default */.Z)(dateString);
      return (0,format/* default */.Z)(parsedDate, "d MMM yyyy", {
        locale: (0,language/* getDateFnsLocale */.Gr)()
      });
    } catch (e) {
      console.error(e);
      return "";
    }
  };

  var t = (0,lang/* useTranslate */.q)();
  (0,useClickAway/* default */.Z)(sidebarRef, function (e) {
    onClose();
  });
  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("PodcastSidebar", goBackCallback, open);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
    nodeRef: sidebarRef,
    in: open,
    timeout: 400,
    classNames: {
      enterActive: (podcast_player_fullscreen_module_default()).player_sidebar_enter_active,
      enter: (podcast_player_fullscreen_module_default()).player_sidebar_enter,
      enterDone: (podcast_player_fullscreen_module_default()).player_sidebar_enter_done,
      exit: (podcast_player_fullscreen_module_default()).player_sidebar_exit,
      exitActive: (podcast_player_fullscreen_module_default()).player_sidebar_exit_active,
      exitDone: (podcast_player_fullscreen_module_default()).player_sidebar_exit_done
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (podcast_player_fullscreen_module_default()).player_sidebar,
      ref: sidebarRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (podcast_player_fullscreen_module_default()).player_sidebar_inner,
        children: podcastQueue.items.map(function (item, itemIndex) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-navigate-row": open,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (podcast_player_fullscreen_module_default()).queue_item,
              "data-navigate-item": open,
              tabIndex: 0,
              onClick: function onClick() {
                dispatch(player/* playerActions.setPodcastQueue */.i9.setPodcastQueue({
                  items: podcastQueue.items,
                  activeIndex: itemIndex
                }));
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (podcast_player_fullscreen_module_default()).queue_item_name,
                children: item.name
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (podcast_player_fullscreen_module_default()).queue_item_duration,
                children: [formatPublishDate((item === null || item === void 0 ? void 0 : item.published) || ""), " -", " ", (0,date/* formatTimeWithUnits */.G)(item.duration, t)]
              })]
            })
          }, "sidebar-item-".concat(item.permalink));
        })
      })
    })
  });
};

var PodcastSpeedSidebar = function PodcastSpeedSidebar(_ref4) {
  var open = _ref4.open,
      onClose = _ref4.onClose,
      onSpeedUp = _ref4.onSpeedUp,
      onSpeedDown = _ref4.onSpeedDown,
      currentSpeed = _ref4.currentSpeed;
  var sidebarRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)(open);

  var _useFeaturesContext2 = (0,features_context/* useFeaturesContext */.Pp)(),
      arrowNavigationEnabled = _useFeaturesContext2.arrowNavigationEnabled;

  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("PodcastSpeedSidebar", goBackCallback, open);
  (0,useClickAway/* default */.Z)(sidebarRef, function (e) {
    var _e$composedPath;

    if (open && !(e !== null && e !== void 0 && (_e$composedPath = e.composedPath()) !== null && _e$composedPath !== void 0 && _e$composedPath.filter(function (item) {
      return item.id === "speed-control-button";
    }).length)) {
      onClose();
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
    nodeRef: sidebarRef,
    in: open,
    timeout: 400,
    classNames: {
      enterActive: (podcast_player_fullscreen_module_default()).player_sidebar_enter_active,
      enter: (podcast_player_fullscreen_module_default()).player_sidebar_enter,
      enterDone: (podcast_player_fullscreen_module_default()).player_sidebar_enter_done,
      exit: (podcast_player_fullscreen_module_default()).player_sidebar_exit,
      exitActive: (podcast_player_fullscreen_module_default()).player_sidebar_exit_active,
      exitDone: (podcast_player_fullscreen_module_default()).player_sidebar_exit_done
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((podcast_player_fullscreen_module_default()).player_sidebar, (podcast_player_fullscreen_module_default()).player_sidebar_speed),
      ref: sidebarRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (podcast_player_fullscreen_module_default()).player_sidebar_inner,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-navigate-row": open,
          className: (podcast_player_fullscreen_module_default()).speed_control,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            "data-navigate-item": open,
            "data-navigate-noscroll": true,
            onClick: function onClick() {
              return onSpeedUp();
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_BigPlus, {})
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (podcast_player_fullscreen_module_default()).current_speed,
          children: [currentSpeed, "x"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-navigate-row": open,
          className: (podcast_player_fullscreen_module_default()).speed_control,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            "data-navigate-item": open,
            "data-navigate-noscroll": true,
            onClick: function onClick() {
              return onSpeedDown();
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_BigMinus, {})
          })
        }), !arrowNavigationEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (podcast_player_fullscreen_module_default()).close_container,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            "data-navigate-item": open,
            className: (podcast_player_fullscreen_module_default()).close,
            "data-navigate-noscroll": true,
            onClick: function onClick() {
              return onClose();
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {})
          })
        })]
      })
    })
  });
};
// EXTERNAL MODULE: ./app/hooks/audio.hook.ts + 1 modules
var audio_hook = __webpack_require__(54008);
// EXTERNAL MODULE: ./app/utils/db.ts
var db = __webpack_require__(43007);
// EXTERNAL MODULE: ./app/utils/audioAds.ts
var audioAds = __webpack_require__(21075);
;// CONCATENATED MODULE: ./app/hooks/vk-fast-forward.hook.ts

var useVirtualFastForward = function useVirtualFastForward(onFastForward, onRewind, enabled) {
  (0,react.useEffect)(function () {
    if (enabled) {
      var eventHandler = function eventHandler(event) {
        if (window["VK_FAST_FWD"] && event.keyCode === window["VK_FAST_FWD"]) {
          onFastForward();
        }

        if (window["VK_REWIND"] && event.keyCode === window["VK_REWIND"]) {
          onRewind();
        }
      };

      document.addEventListener("keydown", eventHandler);
      return function () {
        return document.removeEventListener("keydown", eventHandler);
      };
    }
  }, [onFastForward, onRewind, enabled]);
};
;// CONCATENATED MODULE: ./app/components/podcast-player/podcast-player.component.tsx


























var PodcastPlayer = function PodcastPlayer(_ref) {
  var _podcastChapter$logo, _podcastChapter$logo2;

  var podcastChapter = _ref.podcastChapter,
      podcast = _ref.podcast,
      playerOpen = _ref.playerOpen,
      setPlayerOpen = _ref.setPlayerOpen,
      streams = _ref.streams,
      streamsLoading = _ref.streamsLoading,
      adStreams = _ref.adStreams,
      initialProgress = _ref.initialProgress,
      isOffline = _ref.isOffline,
      sendTargetspotTimeUpdateEvent = _ref.sendTargetspotTimeUpdateEvent,
      sendTargetspotStateUpdateEvent = _ref.sendTargetspotStateUpdateEvent,
      sendTargetspotTrackingEvent = _ref.sendTargetspotTrackingEvent,
      refetchStreams = _ref.refetchStreams,
      streamsLoadError = _ref.streamsLoadError;

  var _useState = (0,react.useState)(null),
      categoryToAddToFavorites = _useState[0],
      setCategoryToAddToFavorites = _useState[1];

  var _useState2 = (0,react.useState)(null),
      categoryToRemoveFromFavorites = _useState2[0],
      setCategoryToRemoveFromFavorites = _useState2[1];

  var _useFavorites = (0,favorites_hook/* useFavorites */.r)(),
      isFavoriteCategory = _useFavorites.isFavoriteCategory,
      addToFavorites = _useFavorites.addToFavorites,
      removeFromFavorites = _useFavorites.removeFromFavorites;

  var t = (0,lang/* useTranslate */.q)();
  var showStreamErrors = (0,toast_component/* useErrorToast */.cM)({
    content: t("playback-error")
  });
  var showHttpStreamErrors = (0,toast_component/* useErrorToast */.cM)({
    content: t("http-error")
  });

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector.session;

  var dispatch = (0,store/* useAppDispatch */.TL)();

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      playerEnabled = _usePlayerContext.playerEnabled,
      isPlaying = _usePlayerContext.isPlaying,
      setPlayerEnabled = _usePlayerContext.setPlayerEnabled,
      setDuration = _usePlayerContext.setDuration,
      setIsPlaying = _usePlayerContext.setIsPlaying,
      setIsMediaLoading = _usePlayerContext.setIsMediaLoading;

  var _useAppSelector2 = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA),
      podcastQueue = _useAppSelector2.podcastQueue;

  var isCurrentCategoryFavorite = isFavoriteCategory(podcast);
  var artwork = (0,react.useMemo)(function () {
    return [{
      src: podcastChapter.logo || podcast.logo,
      sizes: "96x96",
      type: "image/png"
    }, {
      src: podcastChapter.logo || podcast.logo,
      sizes: "128x128",
      type: "image/png"
    }, {
      src: podcastChapter.logo || podcast.logo,
      sizes: "192x192",
      type: "image/png"
    }, {
      src: podcastChapter.logo || podcast.logo,
      sizes: "256x256",
      type: "image/png"
    }, {
      src: podcastChapter.logo || podcast.logo,
      sizes: "384x384",
      type: "image/png"
    }, {
      src: podcastChapter.logo || podcast.logo,
      sizes: "512x512",
      type: "image/png"
    }];
  }, [podcastChapter.logo, podcast.logo]);
  (0,react.useEffect)(function () {
    if (categoryToAddToFavorites) {
      addToFavorites(categoryToAddToFavorites, isPlaying);
      setCategoryToAddToFavorites(null);
    }
  }, [categoryToAddToFavorites]);
  (0,react.useEffect)(function () {
    if (categoryToRemoveFromFavorites) {
      removeFromFavorites(categoryToRemoveFromFavorites, isPlaying);
      setCategoryToRemoveFromFavorites(null);
    }
  }, [categoryToRemoveFromFavorites]);
  var onPreviousTrack = (0,react.useCallback)(function () {
    if (podcastQueue.items.length > 0 && podcastQueue.activeIndex !== null) {
      if (podcastQueue.activeIndex > 0) {
        dispatch(player/* playerActions.setPodcastQueue */.i9.setPodcastQueue({
          items: podcastQueue.items,
          activeIndex: podcastQueue.activeIndex - 1
        }));
      } else {
        dispatch(player/* playerActions.setPodcastQueue */.i9.setPodcastQueue({
          items: podcastQueue.items,
          activeIndex: podcastQueue.items.length - 1
        }));
      }
    }
  }, [podcastQueue]);
  var onNextTrack = (0,react.useCallback)(function () {
    if (podcastQueue.items.length > 0 && podcastQueue.activeIndex !== null) {
      if (podcastQueue.activeIndex < podcastQueue.items.length - 1) {
        dispatch(player/* playerActions.setPodcastQueue */.i9.setPodcastQueue({
          items: podcastQueue.items,
          activeIndex: podcastQueue.activeIndex + 1
        }));
      } else {
        dispatch(player/* playerActions.setPodcastQueue */.i9.setPodcastQueue({
          items: podcastQueue.items,
          activeIndex: 0
        }));
      }
    }
  }, [podcastQueue]);

  var onFavoriteToggle = function onFavoriteToggle(enabled) {
    if (enabled) {
      setCategoryToAddToFavorites(podcast);
    } else {
      setCategoryToRemoveFromFavorites(podcast);
    }
  };

  var onAdStreamEnd = function onAdStreamEnd() {
    sendTargetspotTrackingEvent(audioAds/* TargetspotEventType.Complete */.q3.Complete);
    dispatch(user/* userActions.setLastAdTimestamp */.hI.setLastAdTimestamp(new Date()));
  };

  var onPlaybackError = function onPlaybackError() {
    var isHttps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (!isHttps) {
      showHttpStreamErrors();
    } else {
      showStreamErrors();
    }
  };

  (0,react.useEffect)(function () {
    if (streamsLoadError) {
      showStreamErrors();
    }
  }, [streamsLoadError]);

  var onSeekBackward = function onSeekBackward() {
    if (!state.activeAdStream) {
      controls.seek(state.time - 10);
    }
  };

  var onSeekForward = function onSeekForward() {
    if (!state.activeAdStream) {
      controls.seek(state.time + 10);
    }
  };

  var onPlay = function onPlay() {
    setPlayerEnabled(true);
  };

  var onStreamEnd = function onStreamEnd() {
    onNextTrack();
  };

  var _useAppAudio = (0,audio_hook/* default */.Z)({
    title: podcastChapter.name,
    artist: podcast.name,
    artwork: artwork,
    audioProps: {
      className: (podcast_player_module_default()).audio_player,
      onPlay: onPlay
    },
    isFavorite: isCurrentCategoryFavorite,
    favoritesEnabled: !!(session !== null && session !== void 0 && session.user),
    streamType: "podcast",
    streams: streams,
    adStreams: adStreams,
    streamsLoading: streamsLoading,
    autoplay: playerEnabled,
    initialProgress: initialProgress,
    onStreamEnd: onStreamEnd,
    onNextTrack: onNextTrack,
    onPreviousTrack: onPreviousTrack,
    onFavoriteToggle: onFavoriteToggle,
    onAdStreamEnd: onAdStreamEnd,
    onPlaybackError: onPlaybackError,
    onSeekBackward: onSeekBackward,
    onSeekForward: onSeekForward,
    permalink: podcast.permalink
  }, [podcastChapter.permalink]),
      audioElement = _useAppAudio.audioElement,
      fallbackAudioElement = _useAppAudio.fallbackAudioElement,
      state = _useAppAudio.state,
      controls = _useAppAudio.controls,
      audioRef = _useAppAudio.audioRef;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      arrowNavigationEnabled = _useFeaturesContext.arrowNavigationEnabled;

  useVirtualFastForward(function () {
    onSeekForward();
  }, function () {
    onSeekBackward();
  }, arrowNavigationEnabled);
  (0,react.useEffect)(function () {
    if (podcastQueue.activeIndex !== null && podcastQueue.items[podcastQueue.activeIndex].permalink !== podcastChapter.permalink) {
      dispatch(player/* playerActions.selectTrack */.i9.selectTrack({
        podcast: {
          podcast: podcast,
          podcastChapter: podcastQueue.items[podcastQueue.activeIndex]
        },
        category: null
      }));
    }
  }, [podcastQueue, podcastChapter, podcast]);
  var playerVariables = {
    "--image-background": "url(".concat((_podcastChapter$logo = podcastChapter.logo) !== null && _podcastChapter$logo !== void 0 ? _podcastChapter$logo : podcast.logo, ")")
  };
  (0,useInterval/* default */.Z)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _audioRef$current;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (state.activeAdStream && state.playing) {
              sendTargetspotTimeUpdateEvent(state);
            }

            if (!(state.time > 0)) {
              _context.next = 15;
              break;
            }

            if (!isOffline) {
              _context.next = 6;
              break;
            }

            db.db.offlineChapters.update(podcastChapter.permalink, {
              playbackProgress: state.time | 0
            }).catch(function (e) {
              return console.error(e);
            });
            _context.next = 15;
            break;

          case 6:
            if (!(session !== null && session !== void 0 && session.user && podcastChapter.duration && !((_audioRef$current = audioRef.current) !== null && _audioRef$current !== void 0 && _audioRef$current.paused))) {
              _context.next = 15;
              break;
            }

            (0,services/* postPillowListenV2ProgressChapter_id */.Ij)(podcastChapter.permalink, {
              finished: (state.time | 0) > podcastChapter.duration - 15,
              seconds: state.time | 0
            });
            _context.prev = 8;
            _context.next = 11;
            return (0,services/* getPillowChapterLive */.bj)(podcastChapter.permalink, {
              isPlaying: state.playing
            });

          case 11:
            _context.next = 15;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](8);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 13]]);
  })), 5000);
  (0,useInterval/* default */.Z)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(podcastChapter.permalink && state.playing)) {
              _context2.next = 8;
              break;
            }

            _context2.prev = 1;
            _context2.next = 4;
            return (0,services/* getPillowChapterLive */.bj)(podcastChapter.permalink, {
              isPlaying: state.playing
            });

          case 4:
            _context2.next = 8;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](1);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 6]]);
  })), 30000);
  var showOfflineError = (0,toast_component/* useErrorToast */.cM)({
    content: t("network.connection-lost")
  });
  (0,react.useEffect)(function () {
    if (!window.navigator.onLine) {
      showOfflineError();
    }
  }, [podcastChapter.permalink]);
  (0,spacebar_hook/* useSpacebarEvent */.G)(controls.toggle);
  (0,react.useEffect)(function () {
    setIsPlaying(state.playing);

    if (podcastChapter.permalink) {
      (0,services/* getPillowChapterLive */.bj)(podcastChapter.permalink, {
        isPlaying: state.playing
      });
    }

    if (state.activeAdStream) {
      sendTargetspotStateUpdateEvent(state);
    }
  }, [state.playing]);
  (0,react.useEffect)(function () {
    setDuration(state.duration || null);
  }, [state.duration]);
  (0,react.useEffect)(function () {
    setIsMediaLoading(state.loading);
  }, [state.loading]);
  (0,react.useEffect)(function () {
    if (isPlaying && !state.playing) {
      controls.play();
    }

    if (!isPlaying && state.playing) {
      controls.pause();
    }
  }, [isPlaying]);
  var closePlayerCallback = (0,react.useCallback)(function () {
    return setPlayerOpen(false);
  }, [setPlayerOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (podcast_player_module_default()).content_wrapper,
      onClick: function onClick() {
        return setPlayerOpen(true);
      },
      style: playerVariables,
      "data-navigate-item": true,
      tabIndex: 0,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (podcast_player_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (podcast_player_module_default()).track_info,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: (podcast_player_module_default()).cover_img,
            src: (_podcastChapter$logo2 = podcastChapter.logo) !== null && _podcastChapter$logo2 !== void 0 ? _podcastChapter$logo2 : podcast.logo,
            alt: ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (podcast_player_module_default()).track_title,
              children: podcastChapter.name
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (podcast_player_module_default()).track_controls,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (podcast_player_module_default()).play_pause_icon,
            onClick: function onClick(e) {
              if (streamsLoadError) {
                refetchStreams();
              } else {
                controls.toggle();
              }

              e.stopPropagation();
            },
            children: !streamsLoadError && (streamsLoading || state.loading) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : state.playing ? /*#__PURE__*/(0,jsx_runtime.jsx)(Pause/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(Play/* default */.Z, {})
          })
        })]
      })
    }), audioElement, fallbackAudioElement, /*#__PURE__*/(0,jsx_runtime.jsx)(PlayerFullScreen, {
      open: playerOpen,
      podcastChapter: podcastChapter,
      podcast: podcast,
      playerCssVariables: playerVariables,
      onClose: closePlayerCallback,
      playbackState: state,
      playbackControls: controls
    })]
  });
};
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./app/context/offline.context.tsx
var offline_context = __webpack_require__(85889);
// EXTERNAL MODULE: ./app/ts.ts
var ts = __webpack_require__(38448);
;// CONCATENATED MODULE: ./app/components/podcast-player/podcast-player-wrapper.component.tsx















var PodcastPlayerWrapper = function PodcastPlayerWrapper() {
  var _activeMedia$podcast, _activeMedia$podcast2;

  var _useState = (0,react.useState)(false),
      playerOpen = _useState[0],
      setPlayerOpen = _useState[1];

  var _useAppSelector = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA),
      activeMedia = _useAppSelector.activeMedia;

  var activeChapter = activeMedia === null || activeMedia === void 0 ? void 0 : (_activeMedia$podcast = activeMedia.podcast) === null || _activeMedia$podcast === void 0 ? void 0 : _activeMedia$podcast.podcastChapter;
  var podcast = activeMedia === null || activeMedia === void 0 ? void 0 : (_activeMedia$podcast2 = activeMedia.podcast) === null || _activeMedia$podcast2 === void 0 ? void 0 : _activeMedia$podcast2.podcast;
  return activeChapter ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((podcast_player_module_default()).wrapper),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PodcastStreamsLoader, {
        podcastChapter: activeChapter,
        podcast: podcast,
        playerOpen: playerOpen,
        setPlayerOpen: setPlayerOpen
      })
    })
  }) : null;
};

var PodcastStreamsLoader = function PodcastStreamsLoader(_ref) {
  var podcast = _ref.podcast,
      playerOpen = _ref.playerOpen,
      setPlayerOpen = _ref.setPlayerOpen,
      podcastChapter = _ref.podcastChapter;

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      playerEnabled = _usePlayerContext.playerEnabled,
      fullscreenPlayerInitialyOpen = _usePlayerContext.fullscreenPlayerInitialyOpen,
      setFullscreenPlayerInitialyOpen = _usePlayerContext.setFullscreenPlayerInitialyOpen;

  var _useAppSelector2 = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector2.session;

  var networkState = (0,useNetworkState/* default */.Z)();

  var _useOfflineContext = (0,offline_context/* useOfflineContext */.tw)(),
      offlineChapters = _useOfflineContext.offlineChapters;

  var _useGetPillowPodcastc = (0,hooks/* useGetPillowPodcastchapterPlay */.lk)(podcastChapter.permalink, {
    enabled: false,
    keepPreviousData: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  }),
      data = _useGetPillowPodcastc.data,
      streamsLoading = _useGetPillowPodcastc.isLoading,
      isError = _useGetPillowPodcastc.isError,
      refetchChapterPlay = _useGetPillowPodcastc.refetch;

  var _useGetPillowListenV = (0,hooks/* useGetPillowListenV2ProgressChapter_id */.Xv)(podcastChapter.permalink, {
    enabled: false
  }),
      chapterProgressResponse = _useGetPillowListenV.data,
      progressLoading = _useGetPillowListenV.isLoading,
      refetchChapterProgress = _useGetPillowListenV.refetch;

  (0,react.useEffect)(function () {
    if (playerEnabled && fullscreenPlayerInitialyOpen) {
      setPlayerOpen(true);
      setFullscreenPlayerInitialyOpen(false);
    }
  }, [podcast.permalink, fullscreenPlayerInitialyOpen]);
  var offlineChapter = (0,react.useMemo)(function () {
    return offlineChapters === null || offlineChapters === void 0 ? void 0 : offlineChapters.find(function (offlineChapter) {
      return offlineChapter.permalink === podcastChapter.permalink;
    });
  }, [offlineChapters, podcastChapter.permalink]);
  var offlineStream = (0,react.useMemo)(function () {
    if (offlineChapter) {
      var _offlineStream = {
        url: URL.createObjectURL(offlineChapter === null || offlineChapter === void 0 ? void 0 : offlineChapter.file),
        protocol: "offline"
      };
      return _offlineStream;
    } else {
      return null;
    }
  }, [podcastChapter, offlineChapter === null || offlineChapter === void 0 ? void 0 : offlineChapter.chapter.permalink]);
  (0,react.useEffect)(function () {
    if (!offlineStream) {
      refetchChapterPlay();

      if (session !== null && session !== void 0 && session.user) {
        refetchChapterProgress();
      }
    }
  }, [offlineStream, networkState, podcastChapter, session]);
  var chapterProgress = (0,react.useMemo)(function () {
    if (offlineChapter) {
      return offlineChapter.playbackProgress;
    } else {
      var _chapterProgressRespo, _chapterProgressRespo2, _chapterProgressRespo3, _chapterProgressRespo4;

      return chapterProgressResponse !== null && chapterProgressResponse !== void 0 && (_chapterProgressRespo = chapterProgressResponse.data) !== null && _chapterProgressRespo !== void 0 && (_chapterProgressRespo2 = _chapterProgressRespo.data) !== null && _chapterProgressRespo2 !== void 0 && _chapterProgressRespo2.finished ? 0 : (chapterProgressResponse === null || chapterProgressResponse === void 0 ? void 0 : (_chapterProgressRespo3 = chapterProgressResponse.data) === null || _chapterProgressRespo3 === void 0 ? void 0 : (_chapterProgressRespo4 = _chapterProgressRespo3.data) === null || _chapterProgressRespo4 === void 0 ? void 0 : _chapterProgressRespo4.seconds) || 0;
    }
  }, [offlineChapter, chapterProgressResponse]);
  var chapterStreams = (0,react.useMemo)(function () {
    var _data$data, _data$data$body, _data$data$body$conte, _data$data$body$conte2;

    return (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$body = _data$data.body) === null || _data$data$body === void 0 ? void 0 : (_data$data$body$conte = _data$data$body.content) === null || _data$data$body$conte === void 0 ? void 0 : (_data$data$body$conte2 = _data$data$body$conte.streams) === null || _data$data$body$conte2 === void 0 ? void 0 : _data$data$body$conte2.filter(ts/* notEmpty */.Dw).sort(function (streamA, streamB) {
      return (streamB.bitrate || 0) - (streamA.bitrate || 0);
    })) || [];
  }, [data]);

  var _useAudioAds = (0,audioAds/* useAudioAds */.BZ)(podcast),
      adStreams = _useAudioAds.adStreams,
      adStreamsLoading = _useAudioAds.adStreamsLoading,
      sendTargetspotTimeUpdateEvent = _useAudioAds.sendTargetspotTimeUpdateEvent,
      sendTrackingEvent = _useAudioAds.sendTrackingEvent,
      sendTargetspotStateUpdateEvent = _useAudioAds.sendTargetspotStateUpdateEvent;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(PodcastPlayer, {
    podcastChapter: podcastChapter,
    podcast: podcast,
    streamsLoadError: isError,
    refetchStreams: refetchChapterPlay,
    playerOpen: playerOpen,
    setPlayerOpen: setPlayerOpen,
    streams: offlineStream ? [offlineStream] : chapterStreams,
    adStreams: adStreams,
    streamsLoading: offlineStream ? false : progressLoading || adStreamsLoading || streamsLoading,
    sendTargetspotTimeUpdateEvent: sendTargetspotTimeUpdateEvent,
    sendTargetspotTrackingEvent: sendTrackingEvent,
    sendTargetspotStateUpdateEvent: sendTargetspotStateUpdateEvent,
    initialProgress: chapterProgress,
    isOffline: !!offlineChapter
  });
};

/* harmony default export */ var podcast_player_wrapper_component = (PodcastPlayerWrapper);

/***/ }),

/***/ 20811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ formatTimeWithUnits; }
/* harmony export */ });
/* unused harmony export formatTime */
var formatTime = function formatTime(seconds) {
  if (seconds !== undefined) {
    var secondsDiff = seconds;
    var hoursDiff = Math.floor(secondsDiff / 3600);
    secondsDiff -= hoursDiff * 3600;
    var minutesDiff = Math.floor(secondsDiff / 60);
    secondsDiff -= minutesDiff * 60;
    secondsDiff |= 0;
    return "".concat(hoursDiff.toString().padStart(2, "0"), ":").concat(minutesDiff.toString().padStart(2, "0"), ":").concat(secondsDiff.toString().padStart(2, "0"));
  }

  return "";
};
var formatTimeWithUnits = function formatTimeWithUnits(seconds, t) {
  if (seconds !== undefined) {
    var secondsDiff = seconds;
    var hoursDiff = Math.floor(secondsDiff / 3600);
    secondsDiff -= hoursDiff * 3600;
    var minutesDiff = Math.floor(secondsDiff / 60);
    secondsDiff -= minutesDiff * 60;
    secondsDiff |= 0;
    var result = '';

    if (hoursDiff) {
      result += "".concat(hoursDiff.toString().padStart(2, "0"), " ").concat(t('time.h'), " ");
    }

    if (minutesDiff) {
      result += "".concat(minutesDiff.toString().padStart(2, "0"), " ").concat(t('time.min'), " ");
    }

    if (secondsDiff) {
      result += "".concat(secondsDiff.toString().padStart(2, "0"), " ").concat(t('time.s'), " ");
    }

    return result;
  }

  return "";
};

/***/ }),

/***/ 80874:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","player_fullscreen_close":"podcast-player-fullscreen_player_fullscreen_close__E7fsJ","button_priamry":"podcast-player-fullscreen_button_priamry__xvZkW","button_secondary":"podcast-player-fullscreen_button_secondary__F_1Nj","play":"podcast-player-fullscreen_play__jHrGw","player_sidebar_enter_active":"podcast-player-fullscreen_player_sidebar_enter_active__BCUfi","player_sidebar_exit_active":"podcast-player-fullscreen_player_sidebar_exit_active__CTaNT","player_fullscreen_enter_active":"podcast-player-fullscreen_player_fullscreen_enter_active__bIZMM","player_fullscreen_exit_active":"podcast-player-fullscreen_player_fullscreen_exit_active__9rF7M","player_fullscreen_controls":"podcast-player-fullscreen_player_fullscreen_controls__jfhcJ","speed_control":"podcast-player-fullscreen_speed_control__MkLrI","player_sidebar":"podcast-player-fullscreen_player_sidebar___wJnY","player_sidebar_inner":"podcast-player-fullscreen_player_sidebar_inner__f3XOe","close_container":"podcast-player-fullscreen_close_container__4dgLd","close":"podcast-player-fullscreen_close__TR0VY","player_sidebar_enter":"podcast-player-fullscreen_player_sidebar_enter__Qfve0","player_sidebar_enter_done":"podcast-player-fullscreen_player_sidebar_enter_done__o0_uw","player_sidebar_exit":"podcast-player-fullscreen_player_sidebar_exit___m8T_","player_sidebar_exit_done":"podcast-player-fullscreen_player_sidebar_exit_done__NDqHH","queue_item":"podcast-player-fullscreen_queue_item__DUHRY","queue_item_name":"podcast-player-fullscreen_queue_item_name__TH22D","queue_item_duration":"podcast-player-fullscreen_queue_item_duration__BHrjV","player_sidebar_speed":"podcast-player-fullscreen_player_sidebar_speed__xJK8V","current_speed":"podcast-player-fullscreen_current_speed__mESHh","invisible":"podcast-player-fullscreen_invisible__cy9DL","player_fullscreen":"podcast-player-fullscreen_player_fullscreen__ilr9p","player_fullscreen_enter":"podcast-player-fullscreen_player_fullscreen_enter__FjiBw","player_fullscreen_enter_done":"podcast-player-fullscreen_player_fullscreen_enter_done__0F31D","player_fullscreen_exit":"podcast-player-fullscreen_player_fullscreen_exit__0WoQL","player_fullscreen_exit_done":"podcast-player-fullscreen_player_fullscreen_exit_done__mkxQ5","player_fullscreen_wrapper":"podcast-player-fullscreen_player_fullscreen_wrapper__xqiro","player_fullscreen_content":"podcast-player-fullscreen_player_fullscreen_content__Miz37","player_fullscreen_inner":"podcast-player-fullscreen_player_fullscreen_inner__9qo_T","player_fullscreen_header":"podcast-player-fullscreen_player_fullscreen_header__t2ewa","player_logo":"podcast-player-fullscreen_player_logo__67fR0","video_ad_header":"podcast-player-fullscreen_video_ad_header__1MUA8","player_fullscreen_track":"podcast-player-fullscreen_player_fullscreen_track__ogRCL","player_fullscreen_track_info_ads":"podcast-player-fullscreen_player_fullscreen_track_info_ads__YCGaR","player_fullscreen_ad_wrapper":"podcast-player-fullscreen_player_fullscreen_ad_wrapper__UQ_x0","video_ad_active":"podcast-player-fullscreen_video_ad_active__sZBOy","player_fullscreen_track_info":"podcast-player-fullscreen_player_fullscreen_track_info__R6Dr4","show_name":"podcast-player-fullscreen_show_name__nHhvv","podcast_logo":"podcast-player-fullscreen_podcast_logo__uxs9m","video_ad":"podcast-player-fullscreen_video_ad__BYTDK","ad_player":"podcast-player-fullscreen_ad_player__vfzwa","ad_header":"podcast-player-fullscreen_ad_header__R2yLx","video_ad_ready":"podcast-player-fullscreen_video_ad_ready__wjmZI","title":"podcast-player-fullscreen_title__CNWS9","chapter_details":"podcast-player-fullscreen_chapter_details__Xu87v","subtitle":"podcast-player-fullscreen_subtitle__aBad5","heart":"podcast-player-fullscreen_heart__sMS96","filled_button":"podcast-player-fullscreen_filled_button__ZOePv","controls_first":"podcast-player-fullscreen_controls_first__Wti1M","controls_last":"podcast-player-fullscreen_controls_last__4g_e3","player_fullscreen_progress_wrapper":"podcast-player-fullscreen_player_fullscreen_progress_wrapper__YS9V9","video_ad_ready_progress":"podcast-player-fullscreen_video_ad_ready_progress__FcM7U","button_jump":"podcast-player-fullscreen_button_jump__XCfmo","player_fullscreen_track_wrapper":"podcast-player-fullscreen_player_fullscreen_track_wrapper__tu5pP","player_fullscreen_time":"podcast-player-fullscreen_player_fullscreen_time___yXjx","player_fullscreen_time_end":"podcast-player-fullscreen_player_fullscreen_time_end__dQGbu","vlyby_container":"podcast-player-fullscreen_vlyby_container__1C15g"};

/***/ }),

/***/ 68525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","content_wrapper":"podcast-player_content_wrapper__ftuIE","wrapper":"podcast-player_wrapper__jta_H","audio_player":"podcast-player_audio_player__B5l4l","navigation_active":"podcast-player_navigation_active__CnTPP","content":"podcast-player_content__54t_J","track_info":"podcast-player_track_info__U6no4","cover_img":"podcast-player_cover_img__vjERW","track_title":"podcast-player_track_title__IjXyo","track_subtitle":"podcast-player_track_subtitle__U18p9","track_controls":"podcast-player_track_controls__c4yrn","play_pause_icon":"podcast-player_play_pause_icon__CaFIp"};

/***/ }),

/***/ 2456:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","slider":"progress-slider_slider__98aAB"};

/***/ })

}]);